<template>
    <div class="version flex-col page">
        <div class="flex-col section space-y-21">
            <!--
            <div class="flex-row justify-center items-center relative group">
                <div class="flex-row items-center section_2 space-x-12 pos">
                    <div class="flex-col justify-start items-center image-wrapper">
                        <img class="image_2" src="https://assets.pfotoo.com/images/version/c131399d633b321fc6b2d29060bcc8f3.png" />
                    </div>
                    <div class="section_3"></div>
                    <div class="flex-col justify-start items-center image-wrapper">
                        <img class="image" src="https://assets.pfotoo.com/images/version/19541ad6a3dc930503857b5fa1bd9d66.png" />
                    </div>
                </div>
                <span class="font_1 text">升级版本</span>
            </div>
            -->
            <div class="flex-col group_2">
                <div class="flex align-center justify-between group_3">
                    <div class="flex-row items-center space-x-10">
                        <img
                                class="shrink-0 image_3"
                                :src="userinfo.avatar"
                        />
                        <span class="font_1 text_3 text-cut-2" style="width: 100px;">{{userinfo.userName}}</span>
                    </div>
                    <div class="flex-row items-center section_4 space-x-28">
                        <span class="font_2 text_4"  @click="services">兑换码</span>
                        <div class="flex-col items-center shrink-0">
                            <span class="font_2 text_2">{{VERSIONS[userinfo.vipType]?VERSIONS[userinfo.vipType].versionName:''}}</span>
                            <span class="font_3 text_5">{{userinfo.vipType>0?unixtoTime(userinfo.endTime,'YYYY-MM-DD 到期'):'永久有效'}}</span>
                        </div>
                    </div>
                </div>
                <div class="flex-col section_5 space-y-14">
                    <div class="flex-col justify-start items-center self-center text-wrapper">
                        <span class="font_3 text_6">一站式征集投稿评选</span>
                    </div>
                    <div class="grid">
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/b4031f28354716a34c67c4a01a4f3e83.png" />
                            <span class="font_3">收集素材</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/9a40ce35483a0ed3db8a2f65f63ae4b5.png" />
                            <span class="font_3">无压缩大文件</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/f715cf9110bc21e756fa59f59b3edd77.png" />
                            <span class="font_3">大众投票</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/e3bc711ede107e5839df9e02aff8967d.png" />
                            <span class="font_3">在线打分</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/074ba76ced9a8195c513eee512e45b84.png" />
                            <span class="font_3">一键下载</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/579764f20cbcfe555fad9b0cb1237370.png" />
                            <span class="font_3">品牌内部活动</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/ecbad92006c5655977ec20e0021f52ee.png" />
                            <span class="font_3">团队协作</span>
                        </div>
                        <div class="flex-col items-center grid-item space-y-4">
                            <img class="image_4" src="https://assets.pfotoo.com/images/version/13150631dbfcc2124d596e05a042adb8.png" />
                            <span class="font_3">营销增粉</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-col relative section_6">
            <div class="flex-col group_4">
                <div class="flex-col justify-start relative group_5">
                    <div class="flex-col relative section_8">
                        <div class="flex-col justify-start relative group_6">
                            <template v-if="tabCurrent==2">
                                <div class="flex-row">
                                    <div class="flex-col equal-division-item section_9 space-y-10"
                                         :class="[userinfo.vipType==21?'useed':'',selected==21?'selected':'']"
                                         @click="userClickChecked(21)">
                                        <div class="flex-col items-center space-y-4">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="font_1">企业基础版</span>
                                        </div>
                                        <span class="font_6 text_11">纯净无广告，适合文化品牌活动</span>
                                    </div>
                                    <div class="flex-col equal-division-item_2 section_10 space-y-10"
                                         :class="[userinfo.vipType==22?'useed':'',selected==22?'selected':'']"
                                         @click="userClickChecked(22)">
                                        <div class="flex-col items-center space-y-4">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="font_1">企业标准版</span>
                                        </div>
                                        <span class="font_6 text_12">超大容载，适合企业、政府、媒体</span>
                                    </div>
                                    <div class="flex-col equal-division-item_2 section_11 space-y-10"
                                         :class="[userinfo.vipType==23?'useed':'',selected==23?'selected':'']"
                                         @click="userClickChecked(23)">
                                        <div class="flex-col group_7 space-y-4">
                                            <img
                                                    class="self-center image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <span class="self-start font_1 text_10 text-cut">企业高级版</span>
                                        </div>
                                        <span class="font_6 text_13">海量容载，适合全国全球活动</span>
                                    </div>
                                </div>
                                <div class="flex-row margin-top">
                                    <div class="flex-col equal-division-item section_9 space-y-10" style="height: 75px;text-align: center;"
                                         :class="[userinfo.vipType==99?'useed':'',selected==99?'selected':'']"
                                         @click="userClickChecked(99)">
                                        <div class="flex align-center justify-center">
                                            <img
                                                    class="image_6"
                                                    src="https://assets.pfotoo.com/images/version/21.png"
                                            />
                                            <div class="font_1 margin-left">私有部署</div>
                                        </div>
                                        <div class="font_6">本地部署，多元化部署解决方案</div>
                                    </div>
                                </div>
                            </template>
                            <div v-else="" class="flex-row xxx-1">
                                <div class="flex-col equal-division-item section_9 space-y-10"
                                     :class="[userinfo.vipType==0?'useed':'',selected==0?'selected':'']"
                                     @click="userClickChecked(0)">
                                    <div class="flex-col items-center space-y-4">
                                        <img class="image_6" src="https://assets.pfotoo.com/images/version/0.png" />
                                        <span class="font_1">免费版</span>
                                    </div>
                                    <span class="font_5--1 text_11">适合测试或社团协会、个人活动</span>
                                </div>
                                <div class="flex-col equal-division-item_2 section_10 space-y-10"
                                     :class="[userinfo.vipType==11?'useed':'',selected==11?'selected':'']"
                                     @click="userClickChecked(11)">
                                    <div class="flex-col items-center space-y-4">
                                        <img class="image_6" src="https://assets.pfotoo.com/images/version/11.png" />
                                        <span class="font_1">基础版</span>
                                    </div>
                                    <span class="font_5--1 text_11">
            适用收集投票评选的小微活动
            <br />
          </span>
                                </div>
                                <div class="flex-col equal-division-item_2 section_11 space-y-10"
                                     :class="[userinfo.vipType==12?'useed':'',selected==12?'selected':'']"
                                     @click="userClickChecked(12)">
                                    <div class="flex-col group_5--1 space-y-4">
                                        <img
                                                class="self-center image_6"
                                                src="https://assets.pfotoo.com/images/version/12.png"
                                        />
                                        <span class="self-start font_1">高级版</span>
                                    </div>
                                    <span class="font_5--1 text_12">适用大文件无压缩中小型活动</span>
                                </div>
                            </div>
                        </div>
                        <router-link :to="'/version-map/'+this.tabCurrent">
                            <div class="flex-col justify-start items-center button text-wrapper_4">
                                <span class="font_5 text_14">如何选择版本?(各版本权益对比）</span>
                            </div>
                        </router-link>
                    </div>
                    <div v-if="hasInBusiness==1" class="flex flex-direction align-center justify-center pos_2--x">
                        <span class="font_4 text_7">企业版续费升级</span>
                        <img class="image_5" src="https://assets.pfotoo.com/images/version/5c4bc9a6f087edbb497e74338024dbac.png" />
                    </div>
                    <template v-else="">
                        <template v-if="tabCurrent==2">
                            <div class="flex-col items-end section_7 pos_2">
                                <span class="font_4 text_7">企业版</span>
                                <img class="image_5" src="https://assets.pfotoo.com/images/version/5c4bc9a6f087edbb497e74338024dbac.png" />
                            </div>
                            <div @click="tabs(1)"
                                 class="flex-col justify-start items-start text-wrapper_2 pos_3"><span class="font_5 text_8">个人版</span></div>
                        </template>
                        <template v-else="">
                            <div class="flex-col items-start section_7--1 pos_2--1">
                                <span class="text_7--1">个人版</span>
                                <img class="image_5--1" src="https://assets.pfotoo.com/images/version/5c4bc9a6f087edbb497e74338024dbac.png" />
                            </div>
                            <div @click="tabs(2)"
                                 class="flex-col justify-start items-center text-wrapper_2--1 pos_4--1">
                                <span class="font_4--1 text_8--1">企业版</span></div>
                        </template>
                    </template>
                </div>
                <div class="box-view-grid flex align-center justify-between" @click="services">
                    <div>
                        <img src="https://assets.pfotoo.com/images/version/%E7%BC%96%E7%BB%84%2015@3x.png"
                             style="width: 160px;height: 90px;"/>
                    </div>
                    <div>
                        <img src="https://assets.pfotoo.com/images/version/%E7%BC%96%E7%BB%84%2016@3x.png"
                             style="width: 160px;height: 90px;"/>
                    </div>
                </div>
                <div class="flex-col section_12 space-y-18">
                    <span class="self-center font_1 text_15">常见问题</span>
                    <div class="flex-col space-y-10">
                        <div class="flex-col list-item" v-for="(item, index) in items" :key="index">
                            <div @click="itemsDisplay(index)"
                                 class="flex-row justify-between items-center">
                                <span class="font_5">{{item.title}}</span>
                                <img
                                        class="image_7"
                                        src="https://assets.pfotoo.com/images/version/cee540e2c91dd2277da074d61ea15a1d.png"
                                />
                            </div>
                            <span class="font_7 text_16" :style="{display:item.display?'':'none'}">{{item.desc}}</span>
                        </div>
                    </div>
                    <span class="self-center font_2 text_10" style="color: #cccccc;font-weight: 400;">Ver 5.5.123</span>
                </div>
            </div>
            <div class="flex align-center justify-center relative section_13 view">
                <div v-if="selected>0 && selected<99" @click="showPrices"
                     class="flex-row justify-between items-center section_14" style="width: 100%;" >
                    <div class="flex-row">
                        <span class="self-center font_8">¥</span>
                        <span class="text_22">{{this.prices?this.prices[0].amount/100:'--'}}</span>
                        <span class="self-start font_8 text_24">起</span>
                    </div>
                    <div class="flex-col justify-start items-center button_2"><span class="font_4 text_23">购买</span></div>
                </div>
                <div v-else="" class="button-user" @click="servicesEvent">{{selected==0?'免费版无需开通':'如有需要联系客服升级'}}</div>
            </div>
        </div>
        <services ref="services"></services>
        <pricesDialog ref="pricesDialog" :prices="prices" @event="pricesDialogEvent"
                      :userinfo="userinfo" :hasManager="hasManager" :hasUsePayBut="hasUsePayBut"
                      :selected="selected" :VERSIONS="VERSIONS"></pricesDialog>
        <payedDialog ref="payedDialog" @event="payedDialogEvent"></payedDialog>
        <dialogCode ref="dialogCode" @event="payedDialogEvent"></dialogCode>
        <serviceFixed></serviceFixed>
    </div>
</template>

<script>
  import App from '../util/comfun'
  import services from '../components/service-dialog.vue'
  import pricesDialog from '../components/prices-dialog.vue'
  import payedDialog from '../components/payed-dialog.vue'
  import dialogCode from '../components/checkout/dialogCode.vue'
  import serviceFixed from '../components/service-fixed.vue'
  export default {
    components: {
      services,
      pricesDialog,
      payedDialog,
      dialogCode,
      serviceFixed,
    },
    props: {},
    data() {
      return {
        items: [
          {
              title:'1.购买可以开发票吗？是否支持专票？',
              desc:'购买任何版本或付费，均支持开具发票；支持电子普票和电子专票，如需开具，请联系客服。',
            }, {
              title:'2.购买后是否支持退款？',
              desc:'购买版本及付费为虚拟产品，请您在购买前确认功能内容和条款，一经生效后不支持退订和退款，敬请谅解。',
            }, {
              title:'3.是否支持对公转账？',
              desc:'支持对公，如有需要，请联系客服。',
            }, {
              title:'4.我的权益在哪看？如何查看到期时间？',
              desc:'可在此页面顶部或小程序首页右上角昵称下方查看版本到期时间；权益请参考上方权益对照表。',
            }, {
              title:'5.平台有什么优惠折扣吗？',
              desc:'Fotoo常年无折扣。',
            }, {
              title:'6.平台是否可以免费使用？权益有什么？',
              desc:'有免费版，默认的版本就是免费版，可永久使用；权益可以点击上方“查看各版本权益对比图”。',
            },
        ],
        tabCurrent:1,
        selected:-1,
        hasManager:false,
        userinfo:{},
        VERSIONS:{},
        prices:null,
        hasDisplayDesc:false,
        hasUsePayBut:false,
        hasInBusiness:0,
      };
    },

    methods: {
      tabs(val){
        this.tabCurrent=val
        if(val==2){
          this.checked(21)
        }else{
          this.checked(12)
        }
      },
      async userClickChecked(val){
        this.selected=val
        if(this.selected>0){
          await this.queryPayServiceItemList()
          //hasUsePayBut && selected>0 && selected<99
          if(this.selected>0 && this.selected<99){
            this.showPrices()
          }
        }
      },
      checked(val){
        this.selected=val
        if(this.selected>0){
          this.queryPayServiceItemList()
        }
      },
      isManager(){
        App.demand('user/isManager/current','GET').then(res=>{
          this.hasManager=res.data.isManager===true
          this.getUserInfo()
          this.hasUsePayBut=this.usePayBut()
        })
      },
      async getUserInfo(){
        let userinfo={}
        if(!this.options.uid){//
          userinfo=(await App.demand('/user/detail/current','GET')).data
          let vipinfo=(await App.demand('/user/vipInfo/current','GET')).data
          this.userinfo={
            userName:userinfo.userName,
            avatar:userinfo.avatar,
            id:userinfo.id,
            vipType:vipinfo.vipType,
            endTime:vipinfo.endTime,
          }
        }else{
          userinfo=(await App.demand('/user/info','GET',{
            userId:this.options.uid
          })).data
          this.userinfo={
            userName:userinfo.userName,
            avatar:userinfo.avatar,
            id:userinfo.id,
            vipType:userinfo.vipType,
            endTime:userinfo.endTime,
          }
        }
      },
      async getVersion(){
        let vds=(await App.demand('/activity/version/loadConfigList','GET')).data;
        let vers={};
        vds.forEach(ver=>{
          vers[ver.versionType]=ver
        });
        this.VERSIONS=vers
        ////////
        if(this.options.hasPayed==1){
          this.$refs.payedDialog.show({
            "upinfo":this.options.description+('')+this.VERSIONS[this.options.selected].versionName
          })
        }
        let selected=this.hasInBusiness?21:12
        if(this.selected>0){
          selected=this.selected
        }
        this.checked(selected)
      },
      unixtoTime:App.unixtoTime,
      async queryPayServiceItemList(){
        this.$refs.pricesDialog.hide()
        let res=await App.demand('/activity/payment/queryPayServiceItemList','POST',{
          pageIndex: 1,
          pageSize: 100,
          paymentType: 'versionVip',
          versionType:this.selected,
        })
        //renewalExclusive=1 续费专享
        let prices=res.data.list||[]
        if(this.userinfo.vipType==0){//过滤掉续费专享
          prices=prices.filter(p=>{
            return p.renewalExclusive==0
          })
        }
        this.prices=prices||null
      },
      services(){
        this.$refs.services.show()
      },
      servicesEvent(){
        if(this.selected==0){
          return this.$message({ message: '免费版无需开通', type: "info" });
        }
        this.services()
      },
      showPrices(){
        this.$refs.pricesDialog.show()
      },
      itemsDisplay(index){
        let item=this.items[index]
        item.display=!item.display
        this.items.splice(index, 1, item);
      },
      pricesDialogEvent(e){
        console.log(e)
        if(e.payed){
          this.$refs.payedDialog.show({
            "upinfo":e.item.description+('')+this.VERSIONS[this.selected].versionName
          })
        }
        if(e.payParams){
          this.$refs.dialogCode.show(e)
        }
        this.$refs.pricesDialog.hide()
      },
      payedDialogEvent(e){
        if(e.act=='services'){
          this.$refs.services.show()
        }else if(e.act=='reFlush'){
          this.getUserInfo()
        }
      },
      usePayBut(){
        let hasiPhone=window.navigator.userAgent.toLocaleLowerCase().indexOf('iphone')>-1
        if(this.options.from=='wxlite' && hasiPhone) {
          //return this.hasManager
          return false
        }
        return true
      },
    },
    /**
     * from,token,userId
     */
    mounted(){
      let hasLogined=false
      if(this.$route.params.options){
        try{
          this.options=JSON.parse(decodeURIComponent(this.$route.params.options))
          hasLogined=true
          this.hasInBusiness=this.options.hasInBusiness
          if(this.hasInBusiness==1){
            this.tabCurrent=2
          }
          if(this.options.selected/1>0){
            this.selected=this.options.selected/1
          }
        }catch (e){}
      }
      console.info('hasLogined',hasLogined,typeof this.options)
      if(!hasLogined || !this.options || typeof this.options!='object'){return App.wxLogin()}
      this.getVersion()
      console.log('options',this.options)
      wxlite.setStorageSync('token',this.options.token)
      this.isManager()
      if(this.options.from=='wxlite'){
        document.querySelector('body').setAttribute('style', 'background-color:#f1dab9;')
      }
    },
  };
</script>

<style scoped lang="css">
    body{
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 100%);
    }
    .version.page {
        background-color: #d9bc82;
        height: 100%;
        width: 100%;
        max-width: 395px;
        overflow-y: auto;
        overflow-x: hidden;
        margin: 0 auto;
    }
    .version .section {
        padding: 19px 6px 55px;
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 100%);
        z-index: 0;
    }
    .version .space-y-21 > *:not(:first-child) {
        margin-top: 21px;
    }
    .version .group {
        padding: 7px 0 3px;
    }
    .version .section_2 {
        padding: 6px 11px;
        background-color: #eef2f24d;
        border-radius: 16px;
        border: solid 0.5px #9797970f;
    }
    .version .space-x-12 > *:not(:first-child) {
        margin-left: 12px;
    }
    .version .pos {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .version .image-wrapper {
        width: 19px;
    }
    .version .image_2 {
        width: 8px;
        height: 14px;
    }
    .version .section_3 {
        background-color: #00000033;
        width: 0.5px;
        height: 18.5px;
    }
    .version .image {
        width: 19px;
        height: 19px;
    }
    .version .font_1 {
        font-size: 16px;
        font-family: 'PingFang SC';
        line-height: 22px;
        font-weight: 500;
        color: #875a25;
    }
    .version .text {
        color: #292828;
        font-weight: unset;
    }
    .version .group_2 {
        padding: 0 4px;
    }
    .version .group_3 {
        padding-left: 10px;
        padding-bottom: 9px;
    }
    .version .space-x-10 > *:not(:first-child) {
        margin-left: 10px;
    }
    .version .image_3 {
        border-radius: 20px;
        width: 40px;
        height: 40px;
    }
    .version .text_3 {
        color: #8b5a13;
    }
    .version .section_4 {
        padding: 3px 10px 3px 20px;
        background-image: url('https://assets.pfotoo.com/images/version/a7249d3e227a184b4d8e276434e0df63.png');
        background-position: 0% 0%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 40px;
    }
    .version .space-x-28 > *:not(:first-child) {
        margin-left: 35px;
    }
    .version .font_2 {
        font-size: 12px;
        font-family: 'PingFang SC';
        line-height: 17px;
        font-weight: 600;
    }
    .version .text_4 {
        color: #b7987d;
    }
    .version .text_2 {
        color: #f0d5b1;
    }
    .version .font_3 {
        font-size: 12px;
        font-family: 'PingFang SC';
        line-height: 17px;
        color: #5d5d5d;
    }
    .version .text_5 {
        color: #f0d5b1;
        font-size: 11px;
        line-height: 16px;
    }
    .version .section_5 {
        padding-bottom: 42px;
        background-color: #fff8ed;
        border-radius: 20px;
        border: solid 1px #ffc134;
    }
    .version .space-y-14 > *:not(:first-child) {
        margin-top: 14px;
    }
    .version .text-wrapper {
        padding: 2px 0;
        background-image: url('https://assets.pfotoo.com/images/version/aae5cbed48b82ad586097558a9982756.png');
        background-position: 0% 0%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 230px;
    }
    .version .text_6 {
        color: #ffe4c1;
        font-weight: 500;
    }
    .version .grid {
        height: 134px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
    }
    .version .grid-item {
        padding: 8px 0;
    }
    .version .image_4 {
        border-radius: 50%;
        width: 32px;
        height: 32px;
    }
    .version .section_6 {
        margin-top: -83px;
        background-color: #f7f7f7;
        border-radius: 20px 20px 0 0;
        height: 1015px;
    }
    .version .group_4 {
        padding: 0 10px;
    }
    .version .group_5 {
        padding: 15px 0 10px;
    }
    .version .section_8 {
        padding: 77px 10px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 3px 0px #e9c46a;
        border-radius: 20px;
    }
    .version .group_6 {
        padding-top: 8px;
    }
    .version .equal-division-item {
        flex: 1 1 105px;
    }
    .version .section_9 {
        padding: 12px 4px 18px 4px;
        background-color: #fffaeb;
        border-radius: 8px;
        height: 125px;
    }
    .version .image_6 {
        width: 24px;
        height: 24px;
    }
    .version .font_6 {
        font-size: 12px;
        font-family: 'PingFang SC';
        line-height: 17px;
        color: #bd8d49;
    }
    .version .text_11 {
        text-align: left;
    }
    .version .equal-division-item_2 {
        flex: 1 1 105px;
        margin-left: 10px;
    }
    .version .section_10 {
        padding: 12px 4px 18px;
        background-color: #fffaeb;
        border-radius: 8px;
        height: 125px;
        text-align: center;
    }
    .version .text_12 {
        text-align: left;
    }
    .version .section_11 {
        padding: 12px 4px 18px 4px;
        background-color: #fffaeb;
        border-radius: 8px;
        height: 125px;
        text-align: center;
    }
    .version .space-y-10 > *:not(:first-child) {
        margin-top: 10px;
    }
    .version .group_7 {
        padding: 0 5px;
    }
    .version .space-y-4 > *:not(:first-child) {
        margin-top: 4px;
    }
    .version .text_10 {
        color: #875722;
    }
    .version .text_13 {
        text-align: left;
    }
    .version .text-wrapper_3 {
        padding: 2px 0;
        background-image: linear-gradient(0deg, #fe6e5b 0%, #ff843a 95.95%, #ff843a 100%);
        border-radius: 5px 0px 15px 0px;
        width: 56px;
    }
    .version .pos_4 {
        position: absolute;
        left: 117px;
        top: 0;
    }
    .version .text_9 {
        color: #ffffff;
    }
    .version .button {
        margin-top: 30px;
    }
    .version .text-wrapper_4 {
        padding: 8px 0;
        background-color: #fbebdd;
        border-radius: 8px;
    }
    .version .font_5 {
        font-size: 14px;
        font-family: 'PingFang SC';
        line-height: 20px;
        font-weight: 500;
        color: #5d5d5d;
    }
    .version .text_14 {
        color: #875a25;
    }
    /*企业版 checked*/
    .version .section_7 {
        padding: 21px 49px 6px;
        border-radius: 20px 20px 0 0;
        background-image: url('https://assets.pfotoo.com/images/version/666b04a8d32d3d5bd9a3c75a9c3de67d.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 60%;
    }
    /*个人版*/
    .version .text-wrapper_2 {
        padding: 20px 0 15px;
        border-radius: 20px 0 20px 0;
        background-image: url('https://assets.pfotoo.com/images/version/b8d6ea4dd7bdc39f8568cb2e60ea5843.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 55%;
    }
    .version .pos_2 {
        position: absolute;
        right: 0;
        top: 12px;
        z-index: 1;
    }
    .version .font_4 {
        font-size: 18px;
        font-family: 'PingFang SC';
        line-height: 25px;
        font-weight: 600;
    }
    .version .text_7 {
        color: #88593c;
    }
    .version .image_5 {
        margin-right: 12px;
        width: 30px;
        height: 7px;
    }

    .version .pos_3 {
        position: absolute;
        left: 0;
        top: 15px;
    }
    .version .text_8 {
        margin-left: 50px;
    }
    .version .section_12 {
        padding: 19px 10px 102px;
        background-color: #ffffff;
        border-radius: 20px;
    }
    .version .space-y-18 > *:not(:first-child) {
        margin-top: 18px;
    }
    .version .text_15 {
        color: #353535;
    }
    .version .list-item {
        padding: 10px 12px 10px 20px;
        background-color: #f7f7f7;
        border-radius: 8px;
    }
    .version .image_7 {
        width: 6px;
        height: 11px;
    }
    .version .font_7 {
        font-size: 12px;
        font-family: 'PingFang SC';
        line-height: 17px;
        color: #666666;
    }
    .version .text_16 {
        margin: 15px 6px 0 10px;
        text-align: left;
    }
    .version .section_13 {
        margin-top: -56px;
        padding: 5px 10px 20px;
        background-color: #ffffff;
        box-shadow: 0px 0px 2px 0px #e0e0e080;
        border-radius: 15px 15px 0px 0px;
        position: fixed;
        width: 375px;
        bottom: 0;
        left:calc((100% - 375px) / 2);
    }
    .version .section_14 {
        margin: 0 10px;
        padding-left: 21px;
        background-image: linear-gradient(0deg, #e09d59 0%, #e09d59 -5.84%, #f1dab9 133.57%, #f1dab9 100%);
        border-radius: 22.5px;
    }
    .version .font_8 {
        font-size: 14px;
        font-family: 'PingFang SC';
        line-height: 20px;
        color: #faf6f6;
    }
    .version .text_22 {
        margin-left: 11px;
        color: #faf6f6;
        font-size: 24px;
        font-family: 'PingFang SC';
        font-weight: 600;
        line-height: 33px;
    }
    .version .text_24 {
        margin-left: 5px;
        margin-top: 9px;
    }
    .version .button_2 {
        padding: 10px 0;
        background-image: linear-gradient(116.1deg, #424045 0%, #424045 -17.2%, #615d5d 50%, #615d5d 100%);
        border-radius: 22.5px;
        width: 130px;
        height: 45px;
    }
    .version .text_23 {
        color: #faf6f6;
    }

    /*个人版 checked*/
    .section_7--1 {
        padding: 21px 50px 6px;
        border-radius: 20px 20px 0 0;
        background-image: url('https://assets.pfotoo.com/images/version/fc8be26f2ad487443a62d2c6f3eef679.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        /*width: 218px;*/
        width:60%;
    }
    /*企业版*/
    .text-wrapper_2--1 {
        padding: 19px 0 16px;
        border-radius: 0 20px 0 20px;
        background-image: url('https://assets.pfotoo.com/images/version/a125e01dd626eb81a53177e44cfe2659.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width:55%;
    }
    .pos_2--1 {
        position: absolute;
        left: 0px;
        top: 12px;
        z-index: 1;
    }
    .pos_2--x{
        position: absolute;
        left: 0px;
        top: 12px;
        z-index: 1;
        width: 100%;
        padding-top: 15px;
    }
    .text_7--1 {
        color: #88593c;
        font-size: 18px;
        font-family: 'PingFang SC';
        font-weight: 600;
        line-height: 25px;
    }
    .pos_4--1 {
        position: absolute;
        right: 0px;
        top: 15px;
    }
    .text_8--1 {
        color: #5d5d5d;
    }
    .font_4--1 {
        font-size: 14px;
        font-family: 'PingFang SC';
        line-height: 20px;
        font-weight: 500;
    }
    .section_6--1{
        margin-top: -54px;
        padding-top: 325px;
        background-color: #f7f7f7;
        border-radius: 20px 20px 0 0;
    }
    .image_5--1{
        margin-left: 12px;
        width: 30px;
        height: 7px;
    }
    .font_5--1 {
        font-size: 12px;
        font-family: 'PingFang SC';
        line-height: 17px;
        color: #666666;
    }
    .group_5--1 {
        padding: 0 13px;
    }
    .xxx-1 .section_9,.xxx-1 .section_10,.xxx-1 .section_11{
        background-color: #f4f7ff;
    }

    .selected{
        border: solid 2px #da8d1f;
    }
    .useed{
        position: relative;
    }
    .useed:after{
        content: '使用中';
        position: absolute;
        left: 0px;
        top: -10px;
        padding: 2px 0;
        background-image: -webkit-gradient(linear, left bottom, left top, from(#fe6e5b), color-stop(95.95%, #ff843a), to(#ff843a));
        background-image: linear-gradient(0deg, #fe6e5b 0%, #ff843a 95.95%, #ff843a 100%);
        border-radius: 5px 0px 15px 0px;
        width: 56px;

        color: #ffffff;
        font-size: 12px;
        font-family: 'PingFang SC';
        line-height: 17px;
        text-align: center;
    }
    .button-user{
        width: 355px;
        height: 45px;
        background-image: linear-gradient(1deg, #E09D59 0%, #F1DAB9 100%);
        border-radius: 23px;
        margin-top: 0 auto;

        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        line-height: 45px;
    }
    .box-view-grid{
        width: 355px;
        background: #FFFFFF;
        box-shadow: 0 0 3px 0 #E9C46A;
        border-radius: 20px;
        margin-bottom: 10px;
        padding: 15px 10px 15px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/pages/version.vue